var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "span",
      {
        directives: [
          {
            name: "tooltip",
            rawName: "v-tooltip",
            value: _vm.tipoRazonSocial,
            expression: "tipoRazonSocial"
          }
        ],
        staticClass: "razonSocial"
      },
      [_vm._v(_vm._s(_vm.razonSocial))]
    ),
    _c(
      "div",
      [
        _c("vs-chip", { attrs: { color: _vm.colores.navbar } }, [
          _vm._v(
            " " +
              _vm._s(
                _vm.traducitTipoDocumentoEnPalabras(_vm.documento.tipoDocumento)
              ) +
              " "
          )
        ]),
        _c(
          "vs-chip",
          {
            directives: [
              {
                name: "tooltip",
                rawName: "v-tooltip",
                value: "Folio",
                expression: "'Folio'"
              }
            ],
            attrs: { color: "#aaa" }
          },
          [_vm._v(" # " + _vm._s(_vm.documento.folio) + " ")]
        ),
        _vm.documento.diasParaPago > 0
          ? _c(
              "vs-chip",
              {
                directives: [
                  {
                    name: "tooltip",
                    rawName: "v-tooltip",
                    value:
                      "Días faltantes para pago, tomando en cuenta 30 días",
                    expression:
                      "'Días faltantes para pago, tomando en cuenta 30 días'"
                  }
                ],
                attrs: { color: "primary" }
              },
              [_vm._v(" " + _vm._s(_vm.documento.diasParaPago) + " ")]
            )
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }